import { NgClass } from '@angular/common'
import { Component, Input, input, ViewEncapsulation } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'

import { Select } from 'primeng/select'

import { ErrorMessageComponent } from 'app/_shared/components/error-message/error-message.component'

@Component({
  selector: 'app-select',
  templateUrl: './dropdown.component.html',
  imports: [Select, ReactiveFormsModule, NgClass, ErrorMessageComponent],
  styleUrls: ['./dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropdownComponent {
  @Input() control!: FormControl
  @Input() options: any[] | undefined = []

  placeholder = input<string>()
  label = input<string>()
  name = input<string>('')
  id = input<string>()
  optionLabel = input<string | undefined>(undefined)
  optionValue = input<string | undefined>(undefined)
  errorMessage = input<string>('is required!')
  loading = input<boolean>(false)
  scrollHeight = input<string>('200px')
  panelStyleClass = input<string>('')
  overlayOptions = input<Record<string, unknown> | undefined>(undefined)
}
